const isDev = window.location.hostname === 'dev.oko.ag';
const isQA = window.location.hostname === 'qa.oko.ag';
const isProduction = window.location.hostname === 'directory.oko.ag' || 
                    window.location.hostname.includes('cloudfront.net');

export const API_BASE_URL = isQA
  ? 'https://qa-api.oko.ag/api'
  : isDev
    ? 'https://dev-api.oko.ag/api'
    : isProduction 
      ? process.env.REACT_APP_API_URL_PRODUCTION || 'https://api.oko.ag/api'
      : process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const ROLE_CHOICES = [
  { value: 'land_agent', label: 'Land Agent' },
  { value: 'farmer', label: 'Farmer / Producer / Grower' },
  { value: 'landowner', label: 'Landowner' },
  { value: 'advisor', label: 'Independent Advisor' },
  { value: 'supply_chain', label: 'Supply Chain' },
  { value: 'nfp', label: 'Not-for-profit (supporting farmers)' },
  { value: 'agri_funder', label: 'Agri-funder' },
  { value: 'other', label: 'Other' },
];

export const COUNTRY_CHOICES = [
  { value: 'England', label: 'England' },
  { value: 'Scotland', label: 'Scotland' },
  { value: 'Wales', label: 'Wales' },
  { value: 'Northern Ireland', label: 'Northern Ireland' },
];

export const FUNDING_TYPE_CHOICES = [
  { value: 'government', label: 'Government Funding' },
  { value: 'water_companies', label: 'Water Companies' },
  { value: 'biodiversity_net_gains', label: 'Biodiversity Net Gains (BNG)' },
  { value: 'carbon_schemes', label: 'Carbon Schemes' },
  { value: 'other_natural_capital', label: 'Other Natural Capital' },
  { value: 'supply_chain', label: 'Supply Chain' },
  { value: 'solar', label: 'Solar' },
  { value: 'charities', label: 'Charities' },
  { value: 'local_regional', label: 'Local / Regional Funding' },
  { value: 'other', label: 'Other' },
];

export const FUNDING_TYPES = [
  { value: 'Capital Grant', label: 'Capital Grant' },
  { value: 'Environmental Revenue', label: 'Environmental Revenue' },
  { value: 'Land Management Payment', label: 'Land Management Payment' },
  { value: 'Project Funding', label: 'Project Funding' },
  { value: 'Supply Chain Premium', label: 'Supply Chain Premium' },
];

export const FARMING_TYPES = [
  { value: 'livestock', label: 'Livestock' },
  { value: 'dairy', label: 'Dairy' },
  { value: 'poultry', label: 'Poultry' },
  { value: 'pigs', label: 'Pigs' },
  { value: 'beef', label: 'Beef' },
  { value: 'sheep', label: 'Sheep' },
  { value: 'arable', label: 'Arable' },
  { value: 'mixed', label: 'Mixed' },
  { value: 'horticulture', label: 'Horticulture' },
  { value: 'woodlands', label: 'Woodlands' },
  { value: 'viticulture', label: 'Viticulture' },
  { value: 'orchard', label: 'Orchard' },
];

export const PROTECTED_LAND_TYPES = [
  { value: 'Site of Special Scientific Interest (SSSI)', label: 'Site of Special Scientific Interest (SSSI)' },
  { value: 'Hydrological Structure', label: 'Hydrological Structure' },
  { value: 'Historic or Archaeological Feature (HEFER)', label: 'Historic or Archaeological Feature (HEFER)' },
  { value: 'Scheduled Monument', label: 'Scheduled Monument' },
  { value: 'Ramsar Site', label: 'Ramsar Site' },
  { value: 'Special Area of Conservation', label: 'Special Area of Conservation' },
  { value: 'Species Priority Area', label: 'Species Priority Area' },
  { value: 'Priority Habitat', label: 'Priority Habitat' },
  { value: 'Area of Outstanding Natural Beauty', label: 'Area of Outstanding Natural Beauty' },
  { value: 'Nitrate Vulnerable Zone (NVZ)', label: 'Nitrate Vulnerable Zone (NVZ)' },
  { value: 'Flood Zone', label: 'Flood Zone' },
];

export const LAND_COVERS = [
  { value: 'Arable Land', label: 'Arable Land' },
  { value: 'Permanent Grassland', label: 'Permanent Grassland' },
  { value: 'Permanent crops', label: 'Permanent Crops' },
  { value: 'Woodland', label: 'Woodland' },
  { value: 'Natural Woodland', label: 'Natural Woodland' },
  { value: 'Airstrip/Airports', label: 'Airstrip/Airports' },
  { value: 'Drain/Ditch/Dyke', label: 'Drain/Ditch/Dyke' },
  { value: 'Farm Building', label: 'Farm Building' },
  { value: 'Farmyards', label: 'Farmyards' },
  { value: 'Hard Standings', label: 'Hard Standings' },
  { value: 'Metalled track', label: 'Metalled Track' },
  { value: 'Notional - Scrub', label: 'Notional - Scrub' },
  { value: 'Pond', label: 'Pond' },
  { value: 'Residential dwelling', label: 'Residential Dwelling' },
  { value: 'Residential Gardens', label: 'Residential Gardens' },
  { value: 'Rivers and streams type 1', label: 'Rivers and Streams (Type 1)' },
  { value: 'Rivers and streams type 2', label: 'Rivers and Streams (Type 2)' },
  { value: 'Rivers and streams type 3', label: 'Rivers and Streams (Type 3)' },
  { value: 'Roads', label: 'Roads' },
  { value: 'Rocky outcrop', label: 'Rocky Outcrop' },
  { value: 'Scrub - Ungrazeable', label: 'Scrub - Ungrazeable' },
  { value: 'Sports and Recreation', label: 'Sports and Recreation' },
  { value: 'Storage Area', label: 'Storage Area' },
  { value: 'Structure', label: 'Structure' },
  { value: 'Track - Natural Surface', label: 'Track - Natural Surface' },
  { value: 'Relevant non-agricultural land cover (e.g. scrub, scree, bracken and bog)', label: 'Relevant Non-Agricultural Land Cover' },
  { value: 'Coastal Features', label: 'Coastal Features' },
  { value: 'Marine Wetland', label: 'Marine Wetland' },
  { value: 'Inland Wetland', label: 'Inland Wetland' },
  { value: 'Natural transport - tracks and gallops', label: 'Natural Transport - Tracks and Gallops' },
  { value: 'Water or Irrigation Features', label: 'Water or Irrigation Features' },
];

export const LAND_TYPES = [
  // Cropland
  { value: 'Arable', label: 'Arable' },
  { value: 'Permanent Crops', label: 'Permanent Crops' },
  { value: 'Horticulture', label: 'Horticulture' },
  { value: 'Viticulture', label: 'Viticulture' },
  { value: 'Fallow', label: 'Fallow' },
  // Built
  { value: 'Buildings', label: 'Buildings' },
  { value: 'Farmyard', label: 'Farmyard' },
  // Boundaries
  { value: 'Hedgerows', label: 'Hedgerows' },
  { value: 'Stone Walls', label: 'Stone Walls' },
  { value: 'Ditches', label: 'Ditches' },
  { value: 'Margins', label: 'Margins' },
  { value: 'Buffer Strips', label: 'Buffer Strips' },
  // Grassland
  { value: 'Improved Grassland', label: 'Improved Grassland' },
  { value: 'Unimproved Grassland', label: 'Unimproved Grassland' },
  { value: 'Semi-improved Grassland', label: 'Semi-improved Grassland' },
  { value: 'Species-rich Grassland', label: 'Species-rich Grassland' },
  { value: 'Temporary Grassland', label: 'Temporary Grassland' },
  { value: 'Permanent Grassland', label: 'Permanent Grassland' },
  // Trees & woodland
  { value: 'Agroforestry', label: 'Agroforestry' },
  { value: 'Trees (non-woodland)', label: 'Trees (non-woodland)' },
  { value: 'Orchards', label: 'Orchards' },
  { value: 'Parklands', label: 'Parklands' },
  { value: 'Woodland and Forest', label: 'Woodland and Forest' },
  { value: 'Wood Pasture', label: 'Wood Pasture' },
  // Water & wetland
  { value: 'Coastal', label: 'Coastal' },
  { value: 'Lowland Peat', label: 'Lowland Peat' },
  { value: 'Peat', label: 'Peat' },
  { value: 'Ponds', label: 'Ponds' },
  { value: 'Waterbodies (ponds, lakes, rivers)', label: 'Waterbodies (ponds, lakes, rivers)' },
  { value: 'Wetland', label: 'Wetland' },
  // Upland & heath
  { value: 'Lowland Heath', label: 'Lowland Heath' },
  { value: 'Moorlands', label: 'Moorlands' },
  { value: 'Scrub', label: 'Scrub' },
  { value: 'Uplands', label: 'Uplands' },
];

export const FUNDING_AIMS = [
  { value: 'Soil Health', label: 'Soil Health' },
  { value: 'Compaction', label: 'Compaction' },
  { value: 'Erosion', label: 'Erosion' },
  { value: 'Poaching', label: 'Poaching' },
  { value: 'Runoff', label: 'Runoff' },
  { value: 'Water Quality', label: 'Water Quality' },
  { value: 'Flood Mitigation', label: 'Flood Mitigation' },
  { value: 'Leaching', label: 'Leaching' },
  { value: 'Water Storage', label: 'Water Storage' },
  { value: 'Air Quality', label: 'Air Quality' },
  { value: 'Carbon Sequestration', label: 'Carbon Sequestration' },
  { value: 'Biodiversity', label: 'Biodiversity' },
  { value: 'Pollinators', label: 'Pollinators' },
  { value: 'Wildlife', label: 'Wildlife' },
  { value: 'Habitat Creation & Management', label: 'Habitat Creation & Management' },
  { value: 'Species Recovery', label: 'Species Recovery' },
  { value: 'Integrated Pest Management', label: 'Integrated Pest Management' },
  { value: 'Landscape Character', label: 'Landscape Character' },
  { value: 'Historic & Archaeological Features', label: 'Historic & Archaeological Features' },
  { value: 'Animal Health & Welfare', label: 'Animal Health & Welfare' },
  { value: 'Education', label: 'Education' },
  { value: 'Public Access', label: 'Public Access' },
  { value: 'Biosecurity', label: 'Biosecurity' },
  { value: 'Diversification', label: 'Diversification' },
  { value: 'Productivity', label: 'Productivity' },
  { value: 'Research and Development', label: 'Research and Development' },
  { value: 'Wildfire', label: 'Wildfire' },
];

export const INTERESTS = [
  { value: 'Agroforestry', label: 'Agroforestry' },
  { value: 'Livestock Management', label: 'Livestock Management' },
  { value: 'Manure and Slurry Management', label: 'Manure and Slurry Management' },
  { value: 'Native Breeds', label: 'Native Breeds' },
  { value: 'Organic Farming', label: 'Organic Farming' },
  { value: 'Regenerative Agriculture', label: 'Regenerative Agriculture' },
  { value: 'Precision Farming', label: 'Precision Farming' },
  { value: 'Boundaries', label: 'Boundaries' },
  { value: 'Buffer Strips', label: 'Buffer Strips' },
  { value: 'Cover Crops', label: 'Cover Crops' },
  { value: 'Fencing', label: 'Fencing' },
  { value: 'Integrated Pest Management', label: 'Integrated Pest Management' },
  { value: 'Low or No Inputs', label: 'Low or No Inputs' },
  { value: 'Margins', label: 'Margins' },
  { value: 'Minimal or No-till Farming', label: 'Minimal or No-till Farming' },
  { value: 'Natural Capital', label: 'Natural Capital' },
  { value: 'Nutrient Management', label: 'Nutrient Management' },
  { value: 'Vegetation Control', label: 'Vegetation Control' },
  { value: 'Assessments', label: 'Assessments' },
  { value: 'Energy', label: 'Energy' },
  { value: 'Equipment and Machinery', label: 'Equipment and Machinery' },
  { value: 'Robotics', label: 'Robotics' },
  { value: 'People', label: 'People' },
  { value: 'Trees', label: 'Trees' },
];

export const LOCATIONS = [
  { value: 'uk', label: 'All Locations' },
  { value: 'england', label: 'England' },
  { value: 'scotland', label: 'Scotland' },
  { value: 'wales', label: 'Wales' },
  { value: 'northern_ireland', label: 'Northern Ireland' },
];

export const COUNTIES_BY_COUNTRY = [
  {
    country: 'England',
    counties: [
      'Bedfordshire', 'Berkshire', 'Bristol', 'Buckinghamshire', 'Cambridgeshire',
      'Cheshire', 'City of London', 'Cornwall', 'County Durham', 'Cumbria',
      'Derbyshire', 'Devon', 'Dorset', 'East Riding of Yorkshire', 'East Sussex',
      'Essex', 'Gloucestershire', 'Greater London', 'Greater Manchester', 'Hampshire',
      'Herefordshire', 'Hertfordshire', 'Isle of Wight', 'Kent', 'Lancashire',
      'Leicestershire', 'Lincolnshire', 'Merseyside', 'Norfolk', 'North Yorkshire',
      'Northamptonshire', 'Northumberland', 'Nottinghamshire', 'Oxfordshire', 'Rutland',
      'Shropshire', 'Somerset', 'South Yorkshire', 'Staffordshire', 'Suffolk',
      'Surrey', 'Tyne and Wear', 'Warwickshire', 'West Midlands', 'West Sussex',
      'West Yorkshire', 'Wiltshire', 'Worcestershire',
    ],
  },
  {
    country: 'Scotland',
    counties: [
      'Aberdeen City', 'Aberdeenshire', 'Angus', 'Argyll and Bute', 'Clackmannanshire',
      'Dumfries and Galloway', 'Dundee City', 'East Ayrshire', 'East Dunbartonshire',
      'East Lothian', 'East Renfrewshire', 'City of Edinburgh', 'Falkirk', 'Fife',
      'Glasgow City', 'Highland', 'Inverclyde', 'Midlothian', 'Moray',
      'Na h-Eileanan Siar', 'North Ayrshire', 'North Lanarkshire', 'Orkney Islands',
      'Perth and Kinross', 'Renfrewshire', 'Scottish Borders', 'Shetland Islands',
      'South Ayrshire', 'South Lanarkshire', 'Stirling', 'West Dunbartonshire', 'West Lothian',
    ],
  },
  {
    country: 'Wales',
    counties: [
      'Blaenau Gwent', 'Bridgend', 'Caerphilly', 'Cardiff', 'Carmarthenshire',
      'Ceredigion', 'Conwy', 'Denbighshire', 'Flintshire', 'Gwynedd',
      'Isle of Anglesey', 'Merthyr Tydfil', 'Monmouthshire', 'Neath Port Talbot',
      'Newport', 'Pembrokeshire', 'Powys', 'Rhondda Cynon Taf', 'Swansea',
      'Torfaen', 'Vale of Glamorgan', 'Wrexham',
    ],
  },
  {
    country: 'Northern Ireland',
    counties: ['Antrim', 'Armagh', 'Down', 'Fermanagh', 'Londonderry', 'Tyrone'],
  },
];

export const STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'closed', label: 'Closed' },
  { value: 'coming_soon', label: 'Coming Soon' },
  { value: 'invitation_only', label: 'Invitation Required' },
  { value: 'expression_of_interest', label: 'Express Interest' },
  { value: 'historic', label: 'Historic' },
];

export const STATUS_PRIORITY = ['open', 'coming_soon', 'expression_of_interest', 'invitation_only', 'closed', 'historic'];

export const STATUS_COLORS = {
  open: '#2E8B57',
  closed: '#EE4B2B',
  coming_soon: '#F59E0B',
  invitation_only: '#8B5CF6',
  expression_of_interest: '#0891B2',
  historic: '#6B7280',
};

export const STATUS_LABELS = {
  open: 'Open',
  closed: 'Closed',
  coming_soon: 'Coming Soon',
  invitation_only: 'Invitation Required',
  expression_of_interest: 'Express Interest',
  historic: 'Historic',
  not_specified: 'Not specified',
};

export const COMPETITIVE_STATUS = [
  { value: 'Competitive', label: 'Competitive' },
  { value: 'Non-Competitive', label: 'Non-Competitive' },
  { value: 'Criteria Based', label: 'Criteria Based' },
  { value: 'First Come, First Served', label: 'First Come, First Served' },
];

export const COMPETITIVE_COLORS = {
  competitive: '#e65100',
  non_competitive: '#1565c0',
  criteria_based: '#6d28d9',
  first_come: '#0f766e',
};

export const COMPETITIVE_LABELS = {
  competitive: 'Competitive',
  non_competitive: 'Non-Competitive',
  criteria_based: 'Criteria Based',
  first_come: 'First Come, First Served',
};

export const getCompetitiveStyle = (val) => {
  const v = String(val).toLowerCase().replace(/-/g, '_');
  if (v === 'competitive')                              return { bg: COMPETITIVE_COLORS.competitive, color: '#fff', label: COMPETITIVE_LABELS.competitive };
  if (v === 'non_competitive')                          return { bg: COMPETITIVE_COLORS.non_competitive, color: '#fff', label: COMPETITIVE_LABELS.non_competitive };
  if (v === 'criteria_based' || v === 'criteria based') return { bg: COMPETITIVE_COLORS.criteria_based, color: '#fff', label: COMPETITIVE_LABELS.criteria_based };
  if (v.includes('first come'))                         return { bg: COMPETITIVE_COLORS.first_come, color: '#fff', label: COMPETITIVE_LABELS.first_come };
  return { bg: '#616161', color: '#fff', label: val };
};

export const FUNDING_TYPE_COLORS = {
  'Capital Grant': '#2563eb',
  'Environmental Revenue': '#059669',
  'Land Management Payment': '#7c3aed',
  'Project Funding': '#d97706',
  'Supply Chain Premium': '#dc2626',
};

export const FUNDING_TYPE_LABELS = {
  'Capital Grant': 'Capital Grant',
  'Environmental Revenue': 'Environmental Revenue',
  'Land Management Payment': 'Land Management Payment',
  'Project Funding': 'Project Funding',
  'Supply Chain Premium': 'Supply Chain Premium',
};

export const getFundingTypeStyle = (val) => {
  const color = FUNDING_TYPE_COLORS[val];
  if (color) return { bg: color, color: '#fff', label: val };
  return { bg: '#616161', color: '#fff', label: val };
};

export const THEME = {
  primary:      '#615DEC',
  primaryDark:  '#4c47c7',
  primaryDeep:  '#1a1830',
  primaryMid:   '#2D2A6E',
  primaryLight: 'rgba(97,93,236,0.10)',
  pale:         '#F6F5EC',
  white:        '#ffffff',
  textDark:     '#222222',
  textMid:      '#7C7B7B',
  border:       '#e5e7eb',
};

export const getStatusStyle = (status) => {
  if (!status) return null;
  const key = status.toLowerCase();
  const bg = STATUS_COLORS[key] || '#616161';
  const label = key === 'open' ? `✓  ${STATUS_LABELS[key]}` : (STATUS_LABELS[key] || status);
  return { bg, color: '#fff', label };
};

export const protectedLandPill = (status) => {
  const s = (status || '').trim().toLowerCase();
  if (s === 'eligible')         return { bg: '#e8f5e9', color: '#2e7d32', border: '#c8e6c9', icon: '✓', label: 'Eligible' };
  if (s === 'consent required') return { bg: '#fff8e1', color: '#b84d00', border: '#ffe082', icon: '⚠', label: 'Consent Required' };
  if (s === 'ineligible')       return { bg: '#fdecea', color: '#c62828', border: '#f5c6c2', icon: '✕', label: 'Ineligible' };
  return { bg: '#f5f5f5', color: '#616161', border: '#e0e0e0', icon: '?', label: status || 'Not specified' };
};

export const NOTIFICATION_FREQUENCY_OPTIONS = [
  { value: 'immediate', label: 'Immediate - as soon as new opportunities are added' },
  { value: 'daily', label: 'Daily digest - once per day' },
  { value: 'weekly', label: 'Weekly digest - once per week' },
  { value: 'never', label: 'Never - no notifications' },
];
